import React, { useState } from "react";
import { Select } from "antd";
import { Button, Message, Input } from "../../../BP2Components";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { getListStructure } from "services/api/Api";

const { Option } = Select;

const LevelStatusSettings = (props) => {
   const { value, columns, columnsPoints } = props;
   const dispatch = useDispatch();

   const [settings, setSettings] = useState({
      ...value,
      columns: columns,
      columnsPoints: columnsPoints
   });

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(<IntlMessages id="save.modal" />);
   };
   const handleChangeList = (e) => {
      if (e.target.name === "listId") {
         getListStructure(settings.listId).then((res) => {
            const responseData = res.data.getStructure;
            if (responseData.columns) {
               setSettings({
                  ...settings,
                  columns: responseData.columns
               });
            }
         });
      } else {
         getListStructure(settings.listIdForPoints).then((res) => {
            const responseData = res.data.getStructure;
            if (responseData.columns) {
               setSettings({
                  ...settings,
                  columnsPoints: responseData.columns
               });
            }
         });
      }
   };
   const handleChange = (e) => {
      setSettings({ ...settings, [e.target.name]: e.target.value });
   };
   const handleChangeInput = (name) => (value) => {
      setSettings({ ...settings, [name]: value });
   };

   const options =
      settings && settings.columns != null
         ? settings.columns.map((col) => (
              <Option key={col.label} value={col.label}>
                 {col.label}
              </Option>
           ))
         : null;
   const optionsPoints =
      settings && settings.columnsPoints != null
         ? settings.columnsPoints.map((col) => (
              <Option key={col.label} value={col.label}>
                 {col.label}
              </Option>
           ))
         : null;

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div className="widget-settings__inner">
                  <label className="widget-settings__inner__label" key="title">
                     <IntlMessages id="settings.listId" />:
                     <div style={{ display: "flex" }}>
                        <Input
                           type="text"
                           name="listId"
                           defaultValue={value.listId}
                           onChange={handleChange}
                           style={{ width: "100px" }}
                        />
                        <Button
                           className="gx-ml-1"
                           buttonType="primary"
                           name="listId"
                           onClick={handleChangeList}
                        >
                           <IntlMessages id="settings.changeId" />
                        </Button>
                     </div>
                  </label>
                  <label className="widget-settings__inner__label" key="columnToDisplayPhoto">
                     <IntlMessages id="settings.columnToDisplayPhoto" />:
                     <Select
                        defaultValue={
                           settings.columnToDisplayPhoto !== null
                              ? settings.columnToDisplayPhoto
                              : "----Select----"
                        }
                        style={{ width: 220 }}
                        onChange={handleChangeInput("columnToDisplayPhoto")}
                     >
                        {options}
                     </Select>
                  </label>{" "}
                  <label className="widget-settings__inner__label" key="columnToDisplayLevel">
                     <IntlMessages id="settings.columnToDisplayAllRanges" />:
                     <Select
                        defaultValue={
                           settings.columnToDisplayLevel !== null
                              ? settings.columnToDisplayLevel
                              : "----Select----"
                        }
                        style={{ width: 220 }}
                        onChange={handleChangeInput("columnToDisplayLevel")}
                     >
                        {options}
                     </Select>
                  </label>{" "}
                  <label className="widget-settings__inner__label" key="listIdForPoints">
                     <IntlMessages id="settings.listIdForRange" />:
                     <div style={{ display: "flex" }}>
                        <Input
                           type="text"
                           name="listIdForPoints"
                           defaultValue={value.listIdForPoints}
                           onChange={handleChange}
                           style={{ width: "100px" }}
                        />
                        <Button className="gx-ml-1" buttonType="primary" onClick={handleChangeList}>
                           <IntlMessages id="settings.changeId" />
                        </Button>
                     </div>
                  </label>
                  <label className="widget-settings__inner__label" key="columnToDisplayPoints">
                     <IntlMessages id="settings.columnToDisplayCurrentRange" />:
                     <Select
                        defaultValue={
                           settings.columnToDisplayPoints !== null
                              ? settings.columnToDisplayPoints
                              : "----Select----"
                        }
                        style={{ width: 220 }}
                        onChange={handleChangeInput("columnToDisplayPoints")}
                     >
                        {optionsPoints}
                     </Select>
                  </label>
               </div>
               <Button key="btn" buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default LevelStatusSettings;
